import Api, {ApiCall, ApiRequest} from "@/lib/Api";
import {setToken} from "@/lib/Storage";
import Modules from "@/lib/Modules";

export default {
    state : {
        user : null,
        token: null,
        loginError: null,
        isLoading: false,
        error: '',
        success : '',
    },
    getters : {
        isLoggedIn : (state) => !!state.user,
        loginError : state => state.loginError,
        error : state => state.error,
        currentUser : state => state.user,
        isLoading : state => state.isLoading,
        success : state => state.success
    },
    actions : {

        async login({commit}, [username, password]) {
            await commit('resetLoginErrors')
            const res = await ApiRequest(ApiCall(Api.Login, {username, password}));
            if (res.token) {
                setToken(res.token);
                await commit('loginSuccess', {user: { id: res.user, permissions: res.permissions, admin: res.admin, brand_id: res.brand_id, app: res.app}, token: res.token })
            }
            else await commit('loginError', res.error)
            return true
        },

        async logout({commit}) {
            // await ApiRequest(ApiCall(Api.Logout));
            setToken('');
            return await commit('logout');
        },

        async checkLogin({dispatch, commit}) {
            const res = await ApiRequest(ApiCall(Api.CheckLogin));
            if (res.user) {
                await commit('loginSuccess', {user: { id: res.user, permissions: res.permissions ? res.permissions : [], admin: res.admin, brand_id: res.brand_id, app: res.app}, token: null })
            }
            if (res.app) {
                dispatch('applyAppSettings', res.app);
            }
            if (res.abilities) {
                dispatch('applyAbilities', res.abilities);
            }
            if (res.modules) {
                dispatch('applyModules', res.modules);
                for (let module of res.modules) {
                    Modules.createStoreModule(module, this)
                }
            }
            return true
        },

        async setLoading({commit}, isLoading) {
            if (isLoading) await commit('loading')
            else await commit('loaded')
            return true
        },

        async setSuccess({commit}, success) {
            await commit('success', success)
            if (success) {
                setTimeout(async () => await commit('clearSuccess'), 3000)
            }
            return true
        },
        async setError({commit}, error) {
            await commit('setError', error)
            if (error) {
                setTimeout(async () => await commit('clearError'), 5000)
            }
            return true
        }

    },
    mutations : {
        resetLoginErrors: (state) => { state.loginError = null },
        loginSuccess: (state, {user, token}) => {
            if (token) state.token = token
            state.user = user
        },
        loginError: (state, loginError) => {
            state.loginError = loginError;
            state.user = state.token = null;
        },
        setError: (state, error) => {
            console.log({error})
            state.error = error;
        },
        logout : (state) => { state.user = state.token = null; },
        loading: (state) => { state.isLoading = true; },
        loaded: (state) => { state.isLoading = false; },
        success: (state, success) => { state.success = success; },
        clearError: state => state.error = '',
        clearSuccess : state => state.success = '',
    }
}
